import { useEffect, useMemo } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';

import { useBot, useResetToken } from '../../../hooks';

const ResetOnClose = () => {
  const location = useLocation();
  const { isExact: isOnLauncherRoute } = useRouteMatch('/');
  const { resetOnClose } = useBot();

  const hasClosedWidget = Boolean(location.state?.closed);

  const { resetToken, isLoading } = useResetToken();

  const shouldReset = useMemo(
    () =>
      resetOnClose &&
      isOnLauncherRoute &&
      hasClosedWidget &&
      !isLoading,
    [resetOnClose, isOnLauncherRoute, hasClosedWidget, isLoading]
  );

  useEffect(() => {
    if (shouldReset) {
      resetToken();
    }
  }, [shouldReset, resetToken]);

  return null;
};

export default ResetOnClose;